// views/LARA.js
import React, { useState, useEffect } from "react";
import openIcon from '../../images/open.svg';

const LARA = ({ reservations, onReservationsChange }) => {

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "#FFD580"; // Orange
      case "active":
        return "#90EE90"; // Green
      case "cancelled":
        return "#FFCCCB"; // Red
      default:
        return "transparent"; // Reserved (no color)
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
  
    // Get the components of the date in UTC
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  
    // Format as DD/MM/YYYY, HH:MMZ
    return `${day}/${month}/${year}, ${hours}:${minutes}z`;
  };

  return (
    <div>
      {/* Top Menu */}
      <div className="text-sm bg-gray-400" style={{ display: "flex", gap: "4px", paddingBottom: "8px" }}>
        <button
          onClick={() => window.open("https://lara.lusep.fi/", "_blank")}
          style={{ backgroundColor: "#4CAF50", color: "white", border: "none", padding: "4px 8px" }}
          className="flex items-center justify-center gap-2"
        >
          Open WBC
          <img className="w-[16px]" src={openIcon} alt="Open"/>
        </button>
      </div>

      {/* Table */}
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr className="bg-gray-400 text-white text-sm" style={{textAlign: 'left'}}>
            <th style={{ padding: "2px" }}>ID</th>
            <th style={{ padding: "2px" }}>CS</th>
            <th style={{ padding: "2px" }}>Activity</th>
            <th style={{ padding: "2px" }}>Areas</th>
            <th style={{ padding: "2px" }}>Start</th>
            <th style={{ padding: "2px" }}>End</th>
          </tr>
        </thead>
        <tbody className="monospace-font text-xs table-line">
          {reservations.length > 0 ? (
            reservations.map((reservation) => (
              <tr
                key={reservation.reservation_id}
                style={{
                  backgroundColor: getStatusColor(reservation.status),
                }}
              >
                <td style={{ padding: "4px" }}>{reservation.reservation_id}</td>
                <td style={{ padding: "4px" }}>{reservation.callsigns.join(", ")}</td>
                <td style={{ padding: "4px" }}>{reservation.activity_type}</td>
                <td style={{ padding: "4px" }}>
                  {reservation.areas.map((area) => area.area_id).join(", ")}
                </td>
                <td style={{ padding: "4px" }}>{formatTimestamp(reservation.start)}</td>
                <td style={{ padding: "4px" }}>{formatTimestamp(reservation.end)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center", padding: "16px" }}>
                No Reservations
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LARA;